import {useCallback} from 'react'

export function reloadWindow() {
  window.__isForceReloading = true
  window.location.reload()
}

/**
 * Safely reload the window, without interfering with the `useBlockerDialog` hook.
 */
export function useReloadWindow() {
  return useCallback(reloadWindow, [])
}
